import React from "react";
import "./Compliance.scss";
import { RenderComplianceTopHeader } from "./CommonComplianceComponents";

const ComplianceHeader = ({ title, subtitle}) => {
  return (
    <RenderComplianceTopHeader
              title={title}
              subtitle={subtitle}
            />
  );
};

export default ComplianceHeader;
